module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"tool-title":"Chronique de mesures","no-data-title":"Aucune donnée","parameter-type":"Paramètre mesuré","data-source":"Source de données","dateFrom":"Début","dateTo":"Fin"},"de":{}}')
  delete Component.options._Ctor
}
